import React, { useState, useEffect } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableWrapper,
  TableAction,
  ModalDeleteConfirm,
  MasterButton,
} from "App/Component/ui";

import { useFetch, useDatatables } from "App/hooks";
import {
  ModalForm,
  headCells,
  deleteMasterGolonganBarangById,
  RESET_STATE_MASTER_GOLONGAN_BARANG,
  urlGetAll,
} from "./helpers";
import { STYLE_DEFAULT_MASTER, TYPE_INSTANCE4 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  defaultDateDisplay,
} from "App/utils/helpers";


  const Status = ({ str }) => {
    if (str === true) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"Aktif"}
          color={"green"}
          type="button"
          disabled
        />
      );
    } else if (str === false) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"Tidak Aktif"}
          color={"secondary"}
          type="button"
          disabled
        />
      );
    }
  };

export default function MasterGolonganBarang() {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useFetch(TYPE_INSTANCE4, urlGetAll, "data");
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState(RESET_STATE_MASTER_GOLONGAN_BARANG);
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_MASTER_GOLONGAN_BARANG);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
      status: row?.status,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  const setNewData = async () => {
    const newData = await fetchData(TYPE_INSTANCE4, urlGetAll, "data");
    console.log(newData);
    setRows(newData);
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const deleteList = async () => {
    const res = await deleteMasterGolonganBarangById(formData.id);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  };

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title='Daftar Golongan Barang Fixed Asset'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>
                <TableCell align="left">{row?.name}</TableCell>
                <TableCell align="left">{row?.remark}</TableCell>
                <TableCell align="center">
                  <Status str={row.status} />
                </TableCell>
                <TableCell align="left">{defaultDateDisplay(row?.createdAt, true)}</TableCell>
                <TableCell align="left">{row?.createdBy}</TableCell>
                <TableCell align="left">{defaultDateDisplay(row?.updatedAt, true)}</TableCell>
                <TableCell align="left">{row?.updatedBy}</TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
